import React from 'react';
import styles from './wish-list-item.module.scss';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { Badge } from './badge';
import Shimmer from 'tradera/legacy/static/components/shimmer/shimmer';
import { ItemDetailsDesktop } from './item-details-desktop';
import { ItemDetailsMobile } from './item-details-mobile';

export const WishListItem = ({
    item,
    existsInState,
    isMobile,
    onGoToVipClick = () => {}
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <div
            className={`d-flex flex-grow-1 py-2 overflow-auto ${styles.item} ${
                !existsInState ? styles.itemRemoved : ''
            }`}>
            <div className="mr-2">
                <a
                    href={toLocalizedUrl(item.itemUrl)}
                    onClick={onGoToVipClick}
                    className={`text-decoration-none d-block ${styles.imageContainer}`}>
                    <img
                        loading="lazy"
                        onLoad={() => <Shimmer width={100} height={100} />}
                        className={`w-100 d-block overflow-hidden ${styles.image}`}
                        src={item.imageUrl.replace('/medium/', '/small-fit/')}
                        title={item.shortDescription}
                        alt={item.shortDescription}
                    />
                    <Badge itemState={item.itemState} />
                </a>
            </div>
            {isMobile ? (
                <ItemDetailsMobile
                    item={item}
                    existsInState={existsInState}
                    onGoToVipClick={onGoToVipClick}
                />
            ) : (
                <ItemDetailsDesktop
                    item={item}
                    existsInState={existsInState}
                    onGoToVipClick={onGoToVipClick}
                />
            )}
        </div>
    );
};
